import { FiArrowUp, FiCheck, FiClock, FiLogIn, FiLogOut } from 'react-icons/fi';
import QrCode from '../components/QrCode';

// Public, inert examples. This value is a dummy, never an employee credential.
const SAMPLE_QR = 'a3f97c21b8e40d65f1a2c9038de74b1502a6cf83917be40d25ca6f381b04e79c';

export function PunchIllustration({ compact = false }: { compact?: boolean }) {
  return <div className={`kl-demo kl-punch-demo${compact ? ' kl-demo-compact' : ''}`}>
    {!compact && <div className="kl-demo-heading"><strong>今日の打刻</strong><span className="kl-demo-status">未出勤</span></div>}
    <div className="kl-demo-clock"><span>9月7日（月）</span><strong>08:59<small>30</small></strong></div>
    <div className="kl-demo-actions" aria-label="打刻ボタンの表示例（操作できません）">
      <span className="kl-demo-action kl-demo-in"><FiLogIn aria-hidden="true" />出勤</span>
      <span className="kl-demo-action kl-demo-out"><FiLogOut aria-hidden="true" />退勤</span>
      {!compact && <><span className="kl-demo-action kl-demo-break"><FiClock aria-hidden="true" />休憩開始</span><span className="kl-demo-action kl-demo-break"><FiClock aria-hidden="true" />休憩終了</span></>}
    </div>
  </div>;
}

export function SharedPunchIllustration() {
  return <figure className="kl-shared-demo">
    <div className="kl-demo kl-terminal-demo">
      <div className="kl-demo-heading"><strong>職場の共用端末</strong><span className="kl-demo-status">QR打刻</span></div>
      <p className="kl-terminal-guide">カメラにQRをかざして打刻</p>
      <div className="kl-terminal-success"><span className="kl-success-icon"><FiCheck aria-hidden="true" /></span><div><strong>出勤しました</strong><span>田中 美咲さん · 09:00</span></div></div>
    </div>
    <p className="kl-qr-direction"><FiArrowUp aria-hidden="true" /><strong>どちらのQRでも打刻できます</strong></p>
    <div className="kl-qr-options">
      <div className="kl-qr-option"><strong>印刷したカード</strong><div className="kl-card-demo"><span>キンログ ／ 打刻用QR</span><QrCode value={SAMPLE_QR} size={88} title="印刷カードに載せた打刻用QRの見本" /><b>田中 美咲</b></div><span>スマホがなくてもOK</span></div>
      <div className="kl-qr-option"><strong>スマホの画面</strong><div className="kl-phone-demo"><span>自分のQRコード</span><QrCode value={SAMPLE_QR} size={88} title="スマートフォンの画面に表示した打刻用QRの見本" /><b>田中 美咲</b></div><span>画面のQRをかざすだけ</span></div>
    </div>
    <figcaption className="kl-demo-caption">画面イメージ</figcaption>
  </figure>;
}

export function HistoryIllustration() {
  return <div className="kl-demo kl-history-demo">
    <div className="kl-demo-heading"><strong>勤怠履歴</strong><span>9月の記録</span></div>
    <div className="kl-summary-grid"><div><span>実労働時間</span><strong>160<small>時間</small></strong></div><div><span>残業時間</span><strong>8<small>時間</small></strong></div></div>
    <table className="kl-demo-table"><caption>田中 美咲さんの勤怠（一部）</caption><thead><tr><th scope="col">日付</th><th scope="col">出勤</th><th scope="col">退勤</th><th scope="col">実働</th></tr></thead><tbody>{[['9/7 月', '09:00', '18:00', '8:00'], ['9/8 火', '09:00', '18:30', '8:30'], ['9/9 水', '09:00', '18:00', '8:00']].map(row => <tr key={row[0]}><th scope="row">{row[0]}</th>{row.slice(1).map((value, i) => <td key={i}>{value}</td>)}</tr>)}</tbody></table>
    <p className="kl-calculation"><FiCheck aria-hidden="true" /><span>休憩1時間を差し引いて、自動計算</span></p>
  </div>;
}

export function LeaveIllustration() {
  return <div className="kl-demo kl-leave-demo">
    <div className="kl-demo-heading"><strong>有給休暇</strong><span>田中 美咲さん</span></div>
    <div className="kl-leave-remaining"><span>残りの有給</span><strong>10<small>日</small></strong><p>有効期限 2027年3月31日</p></div>
    <div className="kl-leave-details"><div><span>付与日数</span><strong>15<small>日</small></strong></div><div><span>取得日数</span><strong>5<small>日</small></strong></div></div>
    <div className="kl-leave-request"><div><strong>9月18日（金）</strong><span>有給休暇 · 1日</span></div><span className="kl-approved"><FiCheck aria-hidden="true" />承認済み</span></div>
  </div>;
}
